<template>
    <div>

        <div class="revision" v-for="revision in frozenRevisions">
            <h4 v-if="progress.isRetaking || frozenRevisions.length > 1" class="tag revision__title">{{ revision.title }}</h4>
            <div class="revision__container revision__container--upload" >
                <div v-for="submission in revision.submissions" class="submission submission--upload">
                    <a href="#" @click.prevent="showImage(submission.data.medium)" class="submission__thumb-link">
                        <img :src="submission.data.thumb" class="submission__thumb" />
                    </a>
                </div>
            </div>
        </div>

        <dropzone
            v-if="!readonly"
            :url="uploadUrl"
            message="Upload foto"
            :value="uploads"
            :extractResultFromResponse="extractResultFromUploadResponse"
            :maxNumberOfFiles="partial.data.max_files || 3"
            @clicked="enlargeThumbnail"
            @success="storeSubmission"
            @removed="removeSubmission"
            ></dropzone>

        <p class="revision__container revision__container--teacher" v-if="readonly && frozenRevisions.length === 0">Foto uploaden door leerling</p>

    </div>
</template>


<script>
import { setValidation, deleteSubmission } from 'js/vuex/actions'
import { timestamp, transform } from 'js/vuex/helpers'

import Dropzone from 'js/components/elements/Dropzone.vue'

export default {
    components: { Dropzone },
    props: {
        partial: {},
        progress: {},
        readonly: {
            type: Boolean,
            default: false,
        }
    },
    vuex: {
        actions: {
            addSubmission: ({ dispatch }, submission, partial, progress) => {
                dispatch('SET_SUBMISSION', submission);
                dispatch('ADD_SUBMISSION_TO_PARTIAL', partial.id, submission.id)
                if ( partial.primary ) {
                    dispatch('ADD_PRIMARY_SUBMISSION_TO_PROGRESS', progress.id, submission.id)
                }
            },
            deleteSubmission,
            setValidation,
            showImage: ({dispatch}, image) => {
                dispatch('SHOW_IMAGE', image)
                dispatch('SHOW_MODAL', 'ImageContainer')
            },
        }
    },
    methods: {
        extractResultFromUploadResponse: function(response) {
            const result = transform(response).submissions[0]
            return {
                id: result.id,
                thumb: result.data.thumb,
                submission: result,
            }
        },

        flush: function() {
            // TODO: parent step needs to cancel/wait for currently uploading files
            return Promise.resolve()
        },

        storeSubmission: function(file, data) {
            this.addSubmission(data.submission, this.partial, this.progress)
            this.validate()
        },

        removeSubmission: function(file, data) {
            this.deleteSubmission(this.partial, data.submission.id, this.progress)
                .then( this.validate )
        },

        validate: function() {

            const minlength = this.partial.data === null || this.partial.data.minlength == undefined ? 1 : this.partial.data.minlength
            const validated = this.submissions.length >=  minlength

            if (validated != this.partial.validated) {
                this.setValidation(this.partial.id, validated)
            }

        },

        enlargeThumbnail: function(file, data) {
            this.showImage(data.submission.data.medium)
        },

    },

    computed: {

        uploads: function() {
            return this.submissions.map( submission => ({
                id: submission.id,
                thumb: submission.data.thumb,
                submission: submission
            }))
        },

        uploadUrl: function() {
            return this.$http.options.root + '/partials/' + this.partial.id + '/submissions'
        },

        submissions: function() {
            return this.allSubmissions.filter( s => !s.isFrozen )
        },

        allSubmissions: function() {
            return Object.keys(this.$store.state.submissions.storage)
                .map( id => this.$store.state.submissions.storage[id] )
                .filter( submission =>
                    submission.progress === this.progress.id
                    && submission.partial === this.partial.id
                    && submission.data instanceof Object
                    && submission.data.medium != null
                    && submission.data.thumb != null
                )
        },

        frozenRevisions: function() {

            return this.allSubmissions.reduce( (revs, sub) => {

                if ( !sub.isFrozen ) {
                    return revs
                }

                if ( revs[sub.revision] == null ) {
                    revs[sub.revision] = { title: 'versie ' + (sub.revision + 1), submissions: [] }
                }

                revs[sub.revision].submissions.push(sub)
                return revs
            }, [])

        },
    },

    created: function() {
        if ( ! this.readonly ) {
            this.validate()
        }
    },

}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// UploadPartial.vue?3b697091